import { createStore } from "vuex";

export default createStore({
  state: {
    imeKluba: "Šahovski Klub Batana",
    mailKluba: "sk.batana.rovinj@gmail.com",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
